import React, { FC } from 'react';

import { CalendarIcon } from 'lucide-react';

import { cn } from '../lib/utils';
import { Popover, PopoverContent, PopoverTrigger, UIButton } from '../ui';

interface DatePickerPopperProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  disabled?: boolean;
  className?: string;
  hasActions?: boolean;
  anchorText?: string;
  children: React.ReactNode;
  placeholder: string;
}

export const DatePickerPopper: FC<DatePickerPopperProps> = ({
  isOpen,
  onOpenChange,
  disabled,
  className,
  anchorText,
  hasActions,
  children,
  placeholder
}) => {
  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <UIButton
          disabled={disabled}
          variant="outline"
          className={cn(
            'h-10 w-full justify-start text-left font-normal py-3 shadow-none text-base-foreground border-base-input rounded-md',
            'hover:bg-base-accent',
            anchorText === undefined && 'text-base-mutedForeground',
            disabled && 'opacity-50',
            className
          )}
        >
          <CalendarIcon />
          <span
            className={cn(
              'text-base-mutedForeground',
              anchorText && 'text-base-foreground'
            )}
          >
            {anchorText ?? placeholder}
          </span>
        </UIButton>
      </PopoverTrigger>
      <PopoverContent
        className={`w-auto p-${hasActions ? 2 : 0} bg-base-popover min-w-[296px]`}
        align="start"
        side="bottom"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
};
